import React, { createContext, useContext, useState, useEffect } from 'react';

const QuotesContext = createContext();

export const useQuotes = () => {
  const context = useContext(QuotesContext);
  if (!context) {
    throw new Error('useQuotes must be used within a QuotesProvider');
  }
  return context;
};

export const QuotesProvider = ({ children }) => {
  const [savedQuotes, setSavedQuotes] = useState(() => {
    // Load from localStorage on mount
    try {
      const stored = localStorage.getItem('savedQuotes');
      return stored ? JSON.parse(stored) : [];
    } catch (error) {
      console.error('Error loading saved quotes:', error);
      return [];
    }
  });

  // Save to localStorage whenever savedQuotes changes
  useEffect(() => {
    try {
      localStorage.setItem('savedQuotes', JSON.stringify(savedQuotes));
    } catch (error) {
      console.error('Error saving quotes to localStorage:', error);
    }
  }, [savedQuotes]);

  const saveQuote = (quoteData) => {
    // Deep clone the quote data to avoid reference issues
    const clonedData = JSON.parse(JSON.stringify(quoteData));
    const newQuote = {
      id: Date.now().toString() + '-' + Math.random().toString(36).substr(2, 9), // Ensure unique ID
      ...clonedData,
      savedAt: new Date().toISOString()
    };
    setSavedQuotes(prev => {
      const updated = [...prev, newQuote];
      console.log('Saving quote. Total quotes after save:', updated.length);
      return updated;
    });
    return newQuote.id;
  };

  const removeQuote = (id) => {
    setSavedQuotes(prev => prev.filter(quote => quote.id !== id));
  };

  const clearAllQuotes = () => {
    setSavedQuotes([]);
  };

  const updateQuote = (id, updates) => {
    setSavedQuotes(prev => prev.map(quote => 
      quote.id === id ? { ...quote, ...updates } : quote
    ));
  };

  return (
    <QuotesContext.Provider
      value={{
        savedQuotes,
        saveQuote,
        removeQuote,
        clearAllQuotes,
        updateQuote
      }}
    >
      {children}
    </QuotesContext.Provider>
  );
};

